import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
document.title = "Najah | App Showcase";
render(<App data-id="element-216" />, document.getElementById("root"));